import axios from 'axios';
import React, {useState } from 'react'
import EmailForm from './EmailForm';
import OtpForm from './OtpForm';
import PasswordForm from './PasswordForm';
import { useDispatch, useSelector } from 'react-redux';
import { otpErrorChange, setSignFlag } from '../../../redux/slices/AuthSlice';

const Signup = () => {
    const dispatch = useDispatch()
    const {SignFlag}=useSelector((state)=>state.AuthReducer);
   const backHansel=()=>{
    dispatch(otpErrorChange(""));
    dispatch(setSignFlag(0))
   }
  return (
    <div className='login-body'>
          <i className="fa-regular fa-user"></i>
        <h3>انشاء حساب</h3> 
         {SignFlag!=0&&(<i class="fa-solid fa-arrow-right" onClick={backHansel}></i>)} 
        {SignFlag===0?(
          <EmailForm />
        ):SignFlag===1?(
            <OtpForm/>
        ):
       <PasswordForm/>
        }
        
    </div>
  )
}

export default Signup
